import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

import { Row, Col } from "react-bootstrap";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import CustomPageContent from "./CustomPageContent"


export default class CustomPage extends PureComponent {
  render() {
    const { slug } = this.props.match.params;
    return (
      <div className="no-padding">
        <Helmet>
          <title> {slug} | OpenSeas</title>
        </Helmet>
        <Row>
          <Col xs={12}>
            <Header data={this.props} />
          </Col>
        </Row>
        <Row
          className="BannerRectangleLarge"
          style={{ margin: "8px 0 8px 0", textAlign: "center" }}
        >
          <BannerRectangleLarge />
        </Row>
        <div className="OSPageContainer" style={{ paddingTop: 48, paddingBottom: 48 }}>
            <CustomPageContent {...this.props} url="http://administrator.openseas.devpublisto.com" />
        </div>
        <Row style={{ margin: "0px" }}>
          <Footer />
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/CustomPage/CustomPage.js